var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_1246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2487 42.0001C52.6391 41.3237 52.8818 40.5616 52.8818 39.8773V16.1227C52.8818 15.4384 52.6395 14.6765 52.2489 14.0001L36.125 15.4528L25.033 28L33.8476 40.5712L52.2487 42.0001Z",
    fill: "#00599C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1549 55.4867L50.7271 43.6095C51.3197 43.2673 51.8583 42.6765 52.2488 41.9999L28.0001 28L12.0417 28.564L3.75146 42.0001C4.14187 42.6765 4.68072 43.2675 5.27317 43.6095L25.8453 55.4867C27.0304 56.171 28.9699 56.171 30.1549 55.4867Z",
    fill: "#004482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2489 13.9999C51.8583 13.3233 51.3195 12.7325 50.7271 12.3904L30.1549 0.513253C28.9698 -0.171084 27.0304 -0.171084 25.8453 0.513253L5.27315 12.3905C4.08792 13.0746 3.11841 14.7543 3.11841 16.1227V39.8773C3.11841 40.5616 3.36092 41.3237 3.75155 42.0001L28.0002 28.0001L52.2489 13.9999Z",
    fill: "#659AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 44.5879C18.8532 44.5879 11.4119 37.1466 11.4119 28.0001C11.4119 18.8535 18.8532 11.4122 27.9997 11.4122C33.9017 11.4122 39.4061 14.5883 42.3647 19.701L35.1859 23.8551C33.7052 21.2961 30.9515 19.7062 27.9998 19.7062C23.4265 19.7062 19.7058 23.4267 19.7058 28.0001C19.7058 32.5733 23.4264 36.2939 27.9998 36.2939C30.9518 36.2939 33.7055 34.7041 35.1864 32.1446L42.3652 36.2985C39.4066 41.4117 33.902 44.5879 27.9997 44.5879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5884 27.0786H42.7452V25.2356H40.9023V27.0786H39.0591V28.9217H40.9023V30.7649H42.7452V28.9217H44.5884V27.0786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4995 27.0785H49.6563V25.2355H47.8134V27.0785H45.9702V28.9215H47.8134V30.7648H49.6563V28.9215H51.4995V27.0785Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_1246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCPlus);
export default __webpack_public_path__ + "static/media/icon_c_plus.48c817a23f0c4cbf82138decab43f494.svg";
export { ForwardRef as ReactComponent };